module.exports = __webpack_public_path__ + "assets/pdf/E16-cn-flash-droughts.af67974b.pdf";